module.exports = __webpack_public_path__ + "media/spinner-wheel.233bf4a6.webm";